/**********************************
 * COLLAPSE DIRECTIVE
 *
 * Allow to register elements that can be collapsed / expanded.
 * Directive sumplky switch elements styles when a control is clicked.
 *
 * Usage :
 *
 * <tch-collapsible-elements> <== directive container
 *
 *      <tch-collapsible-control /> <== button (default left / right collapse arrow style applied)
 *
 *      <tch-collapsible-from-class="col-md-3" tch-collapsible-to-class="col-md-3 collapsed">...</div> <== element to collapse / expand
 *      <tch-collapsible-from-class="col-md-6" tch-collapsible-to-class="col-md-9">...</div> <== element to collapse / expand
 *
 * </tch-collapsible-elements />
 *
 */

"use strict";

angular.module("app")

	.directive("tchCollapsibleElements", function () {

		return {
			restrict: "A",
			scope: {
				tchCollapsibleCallback: "&",
				tchCollapsibleInverse: "="
			},
			controller: function ($scope) {
				var collapsed = false;
				var registeredElements = [];
				var controlButton;
				var buttonDefaultExpandedClasses = "glyphicon glyphicon-chevron-left";
				var buttonDefaultCollapsedClasses = "glyphicon glyphicon-chevron-right";

				if($scope.tchCollapsibleInverse){
					var temp = buttonDefaultExpandedClasses;
					buttonDefaultExpandedClasses = buttonDefaultCollapsedClasses;
					buttonDefaultCollapsedClasses = temp;
				}

				/**
                 * Getter to access style from outside
                 * @returns {string}
                 */
				this.getButtonDefaultExpandedClasses = function () {
					return buttonDefaultExpandedClasses;
				};

				/**
                 * Register an element that can be expandded / collapsed.
                 * @param element the element that can be expanded or collapsed
                 * @param startClass initial css class (before transformation)
                 * @param endClass final class (after transformation)
                 */
				this.registerElement = function (element, startClass, endClass) {
					registeredElements.push({
						domElement: element,
						startClass: startClass,
						endClass: endClass
					});
				};

				/**
                 * Register a control that will trigger registered elements transformation.
                 * @param element
                 */
				this.registerControlButton = function (element) {
					controlButton = element;
				};

				/**
                 * collapse logic. Function is triggered from the control button registered with above function.
                 */
				this.toggleCollapse = function () {
					// change elements styles
					for (var i = 0; i < registeredElements.length; i++) {
						var element = registeredElements[i];
						if (collapsed) {
							element.domElement.removeClass(element.endClass);
							element.domElement.addClass(element.startClass);
						} else {
							element.domElement.removeClass(element.startClass);
							element.domElement.addClass(element.endClass);
						}
					}

					// change button style
					if (collapsed) {
						controlButton.removeClass(buttonDefaultCollapsedClasses);
						controlButton.addClass(buttonDefaultExpandedClasses);
					} else {
						controlButton.removeClass(buttonDefaultExpandedClasses);
						controlButton.addClass(buttonDefaultCollapsedClasses);
					}

					// update state
					collapsed = !collapsed;

					// optional callback
					if ($scope.tchCollapsibleCallback) {
						$scope.tchCollapsibleCallback();
					}
				};


			}
		};
	})

	.directive("tchCollapsibleControl", function () {
		return {
			restrict: "A",
			require: "^tchCollapsibleElements",
			link: function (scope, elt, attrs, ctrl) {
				var insideButtonMarkup = angular.element("<span></span>");
				insideButtonMarkup.addClass(ctrl.getButtonDefaultExpandedClasses());
				elt.html(insideButtonMarkup);
				ctrl.registerControlButton(insideButtonMarkup);
				elt.on("click", function () {
					ctrl.toggleCollapse();
				});
			}
		};
	})

	.directive("tchCollapsible", function () {
		return {
			restrict: "A",
			require: "^tchCollapsibleElements",
			link: function (scope, elt, attrs, ctrl) {
				var startClass = attrs.tchCollapsibleFromClass;
				var endClass = attrs.tchCollapsibleToClass;
				ctrl.registerElement(elt, startClass, endClass);
			}
		};
	});